import React from "react";
import { Link, useLocation } from "react-router-dom";
import { House, Buildings, Tag, ChatCircleText } from "@phosphor-icons/react";
import { useLang } from "../lib/i18n";
import { ATIKXZIO_SITE_URL } from "../lib/constants";

const LABELS = {
  en: ["Home", "HMS", "Pricing", "Contact"],
  hi: ["होम", "HMS", "प्राइसिंग", "संपर्क"],
};

const tabs = [
  { to: "/", icon: House },
  { to: ATIKXZIO_SITE_URL, icon: Buildings, external: true },
  { to: "/pricing", icon: Tag },
  { to: "/contact", icon: ChatCircleText },
];

export const MobileTabBar = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  const labels = LABELS[lang];

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-navy/[0.08] bg-white/95 backdrop-blur-xl lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-tab-bar"
    >
      <div className="mx-auto grid max-w-md grid-cols-4">
        {tabs.map((t, i) => {
          const active = !t.external && pathname === t.to;
          const cls = "relative flex flex-col items-center gap-1 py-2.5 transition-colors";
          const inner = (
            <>
              {active && <span className="absolute top-0 h-0.5 w-10 rounded-full bg-electric" />}
              <t.icon size={22} weight={active ? "fill" : "regular"} className={active ? "text-electric" : "text-slate-400"} />
              <span className={`text-[10px] font-bold ${active ? "text-electric-ink" : "text-slate-500"}`}>{labels[i]}</span>
            </>
          );
          return t.external ? (
            <a key={t.to} href={t.to} target="_top" rel="noopener" className={cls} data-testid={`mobile-tab-${i}`}>{inner}</a>
          ) : (
            <Link key={t.to} to={t.to} className={cls} data-testid={`mobile-tab-${i}`}>{inner}</Link>
          );
        })}
      </div>
    </nav>
  );
};
